import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from '../core/net';
import { CodeLookup } from '../actions/action-types';
import { HttpMethods } from '@codametrix/ui-common';
export const codeLookup = createAsyncThunk(CodeLookup.LOOKUP_CODES, async (params)=>{
    const lookupParams = new URLSearchParams([
        [
            'tenantId',
            process.env.REACT_APP_DICT_TENANT_OVERRIDE ?? params.tenantId
        ]
    ]);
    const values = await api({
        endpoint: `/dictionary/code/v2?${lookupParams.toString()}`,
        init: {
            method: HttpMethods.POST
        },
        body: {
            searchTerm: params.searchTerm,
            codeType: params.codeType,
            effectiveDate: params.effectiveDate
        }
    });
    return values;
});
